export default __webpack_public_path__ + "static/media/Bapuji.91164170.png";